import React, { useMemo } from 'react';
import moment from 'moment';
import {
  addUserToFlowErrorTypeToMessage,
  AddUserToFlowFail,
  AddUserToFlowSuccess,
} from '@scale/shared-types';
import { CSVLink } from 'react-csv';

interface AddContributorResultsLinkProps {
  csvData: (AddUserToFlowFail | AddUserToFlowSuccess)[];
}

export const AddContributorResultsLink = ({ csvData }: AddContributorResultsLinkProps) => {
  const date = moment().format('YYYY-MM-DD');
  const addContributorResultsCSVFilename = `add-contributor-results-${date}.csv`;
  const addContributorResultsCSVHeaders = ['Contributor Id', 'Add Status', 'Failure Reason'];
  const addContributorResultsCSVData = useMemo<string[][]>(() => {
    return csvData?.map(result => {
      return [
        result.userId,
        result.success ? 'SUCCESS' : 'FAILED',
        result.success ? '' : addUserToFlowErrorTypeToMessage[result.errorType],
      ];
    });
  }, [csvData]);

  return (
    <CSVLink
      data={addContributorResultsCSVData}
      headers={addContributorResultsCSVHeaders}
      filename={addContributorResultsCSVFilename}
    >
      Export as CSV
    </CSVLink>
  );
};
